import { z } from 'zod';

import {
	CardActionStatus2V5,
	CardActionTypeV5,
} from '../../../../../../../../api/generated/cz.partners.bank.backofficegateway.cards.external';
import { UUID_SCHEMA_WITHOUT_NULL } from '../../../../../../../../const/zod/zod';
import { createDateSchemaWithDefinedMinAndMaxBankValues } from '../../../../../../../../helpers/zod/createDateSchemaWithDefinedMinAndMaxBankValues';

export type ClientCardsClickToPayFilterMessages = {
	dateCantBeEarlierThanBankInceptionDateError: string;
	dateMustBeTodayAtLatestError: string;
};

export const getClientCardsClickToPayFilterFormSchema = (
	errorMessages?: ClientCardsClickToPayFilterMessages,
) => {
	const schema = z.object({
		type: z.enum(CardActionTypeV5).optional(),
		status: z.enum(CardActionStatus2V5).optional(),
		errorMessage: z.string().optional(),
		requestTraceUuid: UUID_SCHEMA_WITHOUT_NULL.optional(),
		actionInitializedAt: createDateSchemaWithDefinedMinAndMaxBankValues({
			minDateErrorMessage:
				errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
			maxDateErrorMessage: errorMessages?.dateMustBeTodayAtLatestError,
		}),
		processedAt: createDateSchemaWithDefinedMinAndMaxBankValues({
			minDateErrorMessage:
				errorMessages?.dateCantBeEarlierThanBankInceptionDateError,
			maxDateErrorMessage: errorMessages?.dateMustBeTodayAtLatestError,
		}),
	});

	return schema;
};

export type ClientCardsClickToPayFilterForm = z.infer<
	ReturnType<typeof getClientCardsClickToPayFilterFormSchema>
>;
